// src/components/repasses/utils/dateUtils.ts

interface DateRange {
	ini: string; // Formato YYYY-MM-DD
	fim: string; // Formato YYYY-MM-DD
}

// Função auxiliar para formatar como YYYY-MM-DD
const formatDate = (date: Date): string => date.toISOString().split("T")[0];

export const getDateRangeFromFilter = (filter: string): DateRange => {
	const now = new Date();
	const currentYear = now.getFullYear();
	let startDate: Date, endDate: Date;

	switch (filter) {
		case "previous_month":
			// Mês anterior (do dia 1 ao último dia)
			startDate = new Date(currentYear, now.getMonth() - 1, 1);
			endDate = new Date(currentYear, now.getMonth(), 0);
			break;

		case "current_month":
			// Mês atual (do dia 1 ao último dia)
			startDate = new Date(currentYear, now.getMonth(), 1);
			endDate = new Date(currentYear, now.getMonth() + 1, 0);
			break;

		default:
			// Tenta tratar como número de mês (0=Jan, 1=Feb, etc.)
			const monthNumber = parseInt(filter);
			if (!isNaN(monthNumber) && monthNumber >= 0 && monthNumber < 12) {
				// Intervalo completo para o mês selecionado no ano atual
				startDate = new Date(currentYear, monthNumber, 1);
				endDate = new Date(currentYear, monthNumber + 1, 0);
			} else {
				// Padrão: Mês atual (Fallback se o filtro for inválido)
				startDate = new Date(currentYear, now.getMonth(), 1);
				endDate = new Date(currentYear, now.getMonth() + 1, 0);
			}
			break;
	}

	return {
		ini: formatDate(startDate),
		fim: formatDate(endDate),
	};
};
